"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initGAForm = exports.isFinalStepOfRegistration = exports.isRegistrationPage = void 0;
var ga_1 = require("../../../build-babel/analytics/ga/ga");
var isRegistrationPage = function isRegistrationPage() {
  var SUBMIT_BUTTON = document.querySelector("button[type='submit']#continue");
  if (!SUBMIT_BUTTON) {
    return false;
  }
  return getComputedStyle(SUBMIT_BUTTON).display !== 'none';
};
exports.isRegistrationPage = isRegistrationPage;
var isFinalStepOfRegistration = function isFinalStepOfRegistration() {
  return !!document.querySelector('.extension_termsOfUseConsentChoice_li');
};
exports.isFinalStepOfRegistration = isFinalStepOfRegistration;
var initGAForm = function initGAForm() {
  var _a, _b, _c, _d, _e;
  // open sign up page
  if (document.getElementById('createAccount')) {
    (_a = document.getElementById('createAccount')) === null || _a === void 0 ? void 0 : _a.addEventListener('click', function () {
      (0, ga_1.pushToDataLayer)(ga_1.GA_EVENTS.OPEN_SIGN_UP);
    });
  }
  // open reset password page
  if (document.getElementById('forgotPassword')) {
    (_b = document.getElementById('forgotPassword')) === null || _b === void 0 ? void 0 : _b.addEventListener('click', function () {
      (0, ga_1.pushToDataLayer)(ga_1.GA_EVENTS.OPEN_RESET_PASSWORD);
    });
  }
  // unsuccessful login
  // for successful - check response success handler
  var loginFormError = document.querySelector('#localAccountForm .error');
  if (loginFormError) {
    var loginFormErrorObserver = new MutationObserver(function () {
      var _a, _b, _c;
      if (loginFormError.style.display !== 'none') {
        if (((_a = loginFormError.textContent) === null || _a === void 0 ? void 0 : _a.includes('The provided credentials are incorrect')) || ((_b = loginFormError.textContent) === null || _b === void 0 ? void 0 : _b.includes("We can't seem to find your account")) || ((_c = loginFormError.textContent) === null || _c === void 0 ? void 0 : _c.includes('We are having trouble signing you in'))) {
          (0, ga_1.pushToDataLayer)(ga_1.GA_EVENTS.UNSUCCESSFUL_LOGIN);
        }
      }
    });
    loginFormErrorObserver.observe(loginFormError, {
      attributes: true,
      childList: true
    });
  }
  // send verification code
  var EMAIL_VERIFICATION_CODE_BUTTON_ID = 'emailVerificationControl_but_send_code';
  var EMAIL_INPUT = 'email';
  if (document.getElementById(EMAIL_VERIFICATION_CODE_BUTTON_ID)) {
    (_c = document.getElementById(EMAIL_VERIFICATION_CODE_BUTTON_ID)) === null || _c === void 0 ? void 0 : _c.addEventListener('click', function () {
      var emailInput = document.getElementById(EMAIL_INPUT);
      if (emailInput && emailInput.value && emailInput.checkValidity()) {
        (0, ga_1.pushToDataLayer)((0, exports.isRegistrationPage)() ? ga_1.GA_EVENTS.SEND_VERIFICATION_CODE_REGISTRATION_PAGE : ga_1.GA_EVENTS.SEND_VERIFICATION_CODE_FORGOT_PASSWORD_PAGE);
      }
    });
  }
  // re-send verification code
  var EMAIL_NEW_VERIFICATION_CODE_BUTTON_ID = 'emailVerificationControl_but_send_new_code';
  if (document.getElementById(EMAIL_NEW_VERIFICATION_CODE_BUTTON_ID)) {
    (_d = document.getElementById(EMAIL_NEW_VERIFICATION_CODE_BUTTON_ID)) === null || _d === void 0 ? void 0 : _d.addEventListener('click', function () {
      (0, ga_1.pushToDataLayer)((0, exports.isRegistrationPage)() ? ga_1.GA_EVENTS.RESEND_VERIFICATION_CODE_REGISTRATION_PAGE : ga_1.GA_EVENTS.RESEND_VERIFICATION_CODE_FORGOT_PASSWORD_PAGE);
    });
  }
  // successful code verification
  var VERIFY_CODE_BUTTON_ID = 'emailVerificationControl_but_verify_code';
  if (document.getElementById(VERIFY_CODE_BUTTON_ID)) {
    var verificationControlObserver;
    (_e = document.getElementById(VERIFY_CODE_BUTTON_ID)) === null || _e === void 0 ? void 0 : _e.addEventListener('click', function () {
      var gaEventSent = false;
      var VERIFICATION_CONTROL = document.getElementById('emailVerificationControl');
      if (VERIFICATION_CONTROL && !verificationControlObserver) {
        verificationControlObserver = new MutationObserver(function () {
          var _a;
          var CHANGE_CLAIMS_BUTTON_ID = 'emailVerificationControl_but_change_claims';
          if (((_a = document.getElementById(CHANGE_CLAIMS_BUTTON_ID)) === null || _a === void 0 ? void 0 : _a.style.display) !== 'none') {
            if (!gaEventSent) {
              (0, ga_1.pushToDataLayer)(ga_1.GA_EVENTS.SUCCESSFUL_CODE_VERIFICATION);
              gaEventSent = true;
            }
            verificationControlObserver === null || verificationControlObserver === void 0 ? void 0 : verificationControlObserver.disconnect();
            verificationControlObserver = undefined;
          }
        });
        verificationControlObserver.observe(VERIFICATION_CONTROL, {
          attributes: true,
          childList: true,
          subtree: true
        });
      }
    });
  }
  // unsuccessful account creation
  // for successful - check azure-forms-success.js file
  if ((0, exports.isRegistrationPage)() && (0, exports.isFinalStepOfRegistration)()) {
    var ERROR_ACCOUNT_CREATION_FIELD_ID = 'claimVerificationServerError';
    var NEXT_STEP_MODAL_ID = 'simplemodal-placeholder';
    var REGISTRATION_FORM = document.getElementById('attributeVerification');
    if (REGISTRATION_FORM) {
      var nextStepShown = false;
      var registrationErrorObserver = new MutationObserver(function () {
        var _a;
        if (nextStepShown) {
          if (((_a = document.getElementById(ERROR_ACCOUNT_CREATION_FIELD_ID)) === null || _a === void 0 ? void 0 : _a.style.display) !== 'none') {
            (0, ga_1.pushToDataLayer)(ga_1.GA_EVENTS.UNSUCCESSFUL_ACCOUNT_CREATION);
          }
          nextStepShown = false;
        } else {
          if (document.getElementById(NEXT_STEP_MODAL_ID)) {
            nextStepShown = true;
          }
        }
      });
      registrationErrorObserver.observe(REGISTRATION_FORM, {
        attributes: true,
        childList: true
      });
    }
  }
};
exports.initGAForm = initGAForm;
//# sourceMappingURL=form.js.map